import { FormRes } from '../../proxy/proxy';
import {
  CLEAR_ALL_DATA,
  FORMS_LOAD_ALL,
  FORMS_RESET_PAGE,
  FORMS_GRID_SORT,
  FORMS_GRID_CURRENT_PAGE,
  FORMS_GRID_SEARCH_TEXT
} from '../actionTypes';

export interface StateType {
  allRows: Array<FormRes>,
  filteredRows: Array<FormRes>,
  searchedText: string,
  currentPage: number,
  sortModel: Array<any>
}

const INITIAL_STATE: StateType = {
  allRows: [],
  filteredRows: [],
  searchedText: '',
  currentPage: 0,
  sortModel: []
};

const getColValue = (row: any, col: string) => {
  if (col === 'isBlocker') {
    return row[col] ? 'yes' : 'no';
  }

  return ((row[col] || '').toString()).toLowerCase();
};

const filterRows = (allRows: Array<FormRes> = [], searchText = '') => {
  const text = searchText.trim().toLowerCase();
  return text ? allRows.filter((row) => {
    if (
      getColValue(row, 'question').indexOf(text) > -1
      || getColValue(row, 'isBlocker').indexOf(text) > -1
    ) {
      return true;
    }
    return false;
  }) : allRows;
};

const reducer = (state = INITIAL_STATE, action: { type: string, data: any }): StateType => {
  switch (action.type) {
    case FORMS_LOAD_ALL:
      return {
        ...state,
        allRows: action.data || [],
        filteredRows: filterRows(action.data || [], state.searchedText),
      };
    case FORMS_RESET_PAGE:
      return {
        ...INITIAL_STATE
      };
    case FORMS_GRID_SORT:
      return {
        ...state,
        sortModel: action.data || []
      };
    case FORMS_GRID_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.data
      };
    case FORMS_GRID_SEARCH_TEXT:
      return {
        ...state,
        searchedText: action.data,
        filteredRows: filterRows(state.allRows, action.data),
        currentPage: 0
      };
    case CLEAR_ALL_DATA:
      return INITIAL_STATE;

    default: return state;
  }
};

export default reducer;
